import React from 'react';
import { XIcon, CheckCircleIcon } from 'lucide-react';
export function SuccessModal({
  onClose
}: {
  onClose: () => void;
}) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-1477">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4" data-id="element-1478">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1479">
          <h3 className="text-lg font-medium text-gray-800" data-id="element-1480">
            Transaction complete
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-1481">
            <XIcon size={20} data-id="element-1482" />
          </button>
        </div>
        <div className="p-6 text-center" data-id="element-1483">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-1484">
            <CheckCircleIcon size={32} className="text-green-600" data-id="element-1485" />
          </div>
          <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="element-1486">
            Payment successful
          </h3>
          <p className="text-gray-600" data-id="element-1487">
            The customer's card has been charged successfully. A receipt has
            been sent to their email address.
          </p>
          <div className="mt-6 bg-gray-50 rounded-lg p-4 flex flex-col items-center" data-id="element-1488">
            <div className="flex justify-between w-full mb-2" data-id="element-1489">
              <span className="text-gray-600" data-id="element-1490">Amount charged:</span>
              <span className="font-medium text-gray-900" data-id="element-1491">$49.99</span>
            </div>
            <div className="flex justify-between w-full mb-2" data-id="element-1492">
              <span className="text-gray-600" data-id="element-1493">Transaction ID:</span>
              <span className="font-medium text-gray-900" data-id="element-1494">
                txn_1K2M3N4O5P6Q7R
              </span>
            </div>
            <div className="flex justify-between w-full" data-id="element-1495">
              <span className="text-gray-600" data-id="element-1496">Customer:</span>
              <span className="font-medium text-gray-900" data-id="element-1497">John Smith</span>
            </div>
          </div>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-1498">
          <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" onClick={onClose} data-id="element-1499">
            Done
          </button>
        </div>
      </div>
    </div>;
}